import { AccountLink } from './AccountLink'
import { withAddressSwitch } from './withAddressSwitch'

export const AccountLinkWithAddressSwitch = withAddressSwitch(AccountLink)
